import * as Yup from "yup";
import { getInitialValues } from "layouts/views/common/common";

const formField = {
  userName: {
    name: "userName",
    label: "User Name",
    type: "text",
    errorMsg: "Return Code is required.",
    required: true,
    maxLength: 100,
    disabled: true,
  },
  password: {
    name: "password",
    label: "Password",
    type: "password",
    errorMsg: "Password is required.",
    required: true,
    maxLength: 100,
  },
  newPassword: {
    name: "newPassword",
    label: "New Password",
    type: "password",
    errorMsg: "Password is required.",
    required: true,
    maxLength: 100,
  },
  reenterNewPassword: {
    name: "reenterNewPassword",
    label: "Reenter New Password",
    type: "password",
    errorMsg: "Password is required.",
    required: true,
    maxLength: 100,
  },
};

const { userName, password, newPassword, reenterNewPassword } = formField;

export const formRender = [[userName], [password], [newPassword], [reenterNewPassword]];

export const initialValues = getInitialValues(formField);

export const changePasswordValidation = Yup.object().shape({
  [userName.name]: Yup.string().nullable().max(userName.maxLength).required(userName.errorMsg),
  [password.name]: Yup.string().nullable().max(password.maxLength).required(password.errorMsg),
  [newPassword.name]: Yup.string().nullable().max(newPassword.maxLength)
    .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\da-zA-Z]).{6,15}$/, 
      "Password must contains 6-15 characters,  one uppercase, one lowercase, one number, and one symbol")
    .required(newPassword.errorMsg),
  [reenterNewPassword.name]: Yup.string().nullable()
    .max(reenterNewPassword.maxLength)
    .oneOf([Yup.ref(newPassword.name), null], "Please key in the same new password")
    .required(reenterNewPassword.errorMsg),
});
